import { useContext } from 'react';
import classNames from 'classnames';
import ElementContext from 'LayoutBuilderUI/components/editors/ElementContext';
import { getRenderedOutputById } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import { useAppSelector } from 'LayoutBuilderUI/reducers/rootReducer';
import { jsx as _jsx } from "react/jsx-runtime";
function PreRenderedElement({
  className
}) {
  const {
    elementHtml,
    id
  } = useContext(ElementContext);
  const renderedHtml = useAppSelector(state => {
    const renderedOutput = id ? getRenderedOutputById(state, id) : undefined;
    return renderedOutput === null || renderedOutput === void 0 ? void 0 : renderedOutput.getHtml();
  });
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx("div", {
      className: classNames('rendered', className),
      dangerouslySetInnerHTML: {
        // Checking `renderedModules` first so we'll show the same content as the
        // early preview. This leads to a smoother transition as it avoids a middle
        // state where we briefly render PTokens as raw HubL.
        __html: renderedHtml || elementHtml
      },
      "data-test-id": "pre-rendered-element"
    })
  );
}
export default PreRenderedElement;